export default {
  listMenu: {
    url: '/mall/myMall/listMenu',
    type: 'post'
  },
  getRule: {
    url: '/mall/rule/execute/stringValue',
    type: 'get'
  }
}
